/**
 * @typedef WizardTerminalObject
 * @type {object}
 * @property {string} kpc - Kymeta product code
 * @property {number} quantity - Number of terminals to add to cart.
 * @property {string} buc - Selected BUC.
 * @property {string} modem - Selected modem.
 * @property {string} sdwan - Selected SDWAN.
 * @property {string} case - Selected case.
 */

/**
 * @typedef WizardConnectivityObject
 * @type {object}
 * @property {string} kpc - Kymeta product code
 * @property {boolean} need - Number of terminals to add to cart.
 * @property {string} package - Selected BUC.
 * @property {string} modem - Selected modem.
 * @property {string} sdwan - Selected SDWAN.
 * @property {string} case - Selected case.
 */

/**
 * @typedef WizardWarrantyObject
 * @type {object}
 * @property {string} kpc - Kymeta product code
 * @property {number} count - Extra years of warranty
 */

import { v4 as uuidv4 } from 'uuid';

/**
 * 
 * @param {WizardTerminalObject} builtTerminal 
 * @param {WizardConnectivityObject} builtConnectivity
 * @param {WizardWarrantyObject} warranty
 * @param {number?} financingMonths
 * @param {string?} cartItemId
 */
const wizardToCartItem = (builtTerminal, builtConnectivity, warranty, financingMonths, cartItemId) => {
  const cartTerminal = {
    // quantity of terminals
    quantity: builtTerminal.quantity,
    // the kpc of the terminal
    kpc: builtTerminal.kpc,
    warranty: {
      originalCount: warranty.count,
      count: warranty.count, // extra years of warranty
      kpc: warranty.kpc, // the kpc of the warranty
    },
    connectivity: {},
    financing: financingMonths ?? 1, // 1 means paid in full, or 'none'
    originalFinancing: financingMonths ?? 1,
    id: cartItemId ?? uuidv4(),
    // used for display purposes only
    item: {
      name: builtTerminal.name,
      buc: builtTerminal.buc,
      modem: builtTerminal.modem,
      sdwan: builtTerminal.sdwan,
      case: builtTerminal.terminalCase,
      warranty: builtTerminal.warranty, // ??
    },
    originalBuiltTerminal: JSON.parse(JSON.stringify(builtTerminal)),
    originalBuiltConnectivity: JSON.parse(JSON.stringify(builtConnectivity))
  }
  if (builtConnectivity.isInterested) {
    cartTerminal.connectivity.custom = builtConnectivity.package == 'custom' ? builtConnectivity.customConfigurationText : ''; // custom connectivity package text
    cartTerminal.connectivity.kpc = builtConnectivity.package == 'custom' ? null : builtConnectivity.kpc; // the kpc of the connectivity package or null if it's custom
  }
  return cartTerminal;
}
export default wizardToCartItem;
